'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export default function PageDataUpdater() {
  const pathname = usePathname();
  const prevActivePageRef = useRef<string | null>(null);

  useEffect(() => {
    let activePage = 'home';

    if (pathname?.startsWith('/work')) activePage = 'work';
    if (pathname?.startsWith('/about')) activePage = 'about';
    if (pathname?.startsWith('/contact')) activePage = 'contact';
    if (pathname?.startsWith('/imprint')) activePage = 'imprint';
    if (pathname?.startsWith('/privacy')) activePage = 'privacy';
    if (pathname?.startsWith('/cv')) activePage = 'cv';

    // Wenn wir auf der gleichen Seite klicken (z.B. auf das Header-Icon),
    // oder wenn wir von einer Seite kommen, bei der wir das Farbschema beibehalten wollen,
    // verhindern wir den Neustart der Farbschema-Transition
    if (
      (prevActivePageRef.current === activePage) || 
      (document.body.dataset.page === activePage)
    ) {
      // Nichts tun, damit die Animation nicht neu startet
      console.log('Verhindere Neustart der Background-Transition für:', activePage);
      return;
    }

    // Aktualisiere das data-page Attribut direkt
    document.body.dataset.page = activePage;
    
    // Füge CV-spezifische Klasse hinzu
    if (activePage === 'cv') {
      document.documentElement.classList.add('cv-page');
    } else {
      document.documentElement.classList.remove('cv-page');
    }

    // Speichere die aktuelle Seite für den nächsten Vergleich
    prevActivePageRef.current = activePage;
  }, [pathname]);

  // Diese Komponente rendert nichts
  return null;
}